import { Injectable } from '@angular/core';
import mixpanel from 'mixpanel-browser';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class MixpanelService {
  private initialized = false;

  /**
   * Production only (`mixpanelToken` in `environment.prod.ts`).
   * Autocapture is off so Mixpanel only receives explicit `track()` calls.
   */
  initialize(): void {
    if (this.initialized) {
      return;
    }
    const token = environment.mixpanelToken;
    if (!environment.production || !token) {
      return;
    }
    try {
      mixpanel.init(token, {
        autocapture: false,
        record_sessions_percent: 100,
        record_mask_all_text: false,
      });
      this.initialized = true;
    } catch {
      /* Do not block bootstrap */
      console.error('Mixpanel init failed');
    }
  }

  isEnabled(): boolean {
    return this.initialized;
  }

  track(eventName: string, properties?: Record<string, unknown>): void {
    if (!this.initialized) {
      return;
    }
    try {
      mixpanel.track(eventName, properties);
    } catch {
      /* Do not break HTTP / UI flows (e.g. RxJS tap) */
      console.error('Mixpanel track failed');
    }
  }

  identify(distinctId: string): void {
    if (!this.initialized) {
      return;
    }
    try {
      mixpanel.identify(distinctId);
    } catch {
      /* Do not break login */
      console.error('Mixpanel identify failed');
    }
  }

  reset(): void {
    if (!this.initialized) {
      return;
    }
    try {
      mixpanel.reset();
    } catch {
      /* Do not break logout */
      console.error('Mixpanel reset failed');
    }
  }
}
